import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar, loadBadges, toggleSidebar } from 'redux/navigation'
import { Button, Header, Icon, Label, Segment, Table } from 'semantic-ui-react'

const mapStateToProps = (state) => {
  const { badges } = state.navigation
  return { badges }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleSidebar,
      hideSidebar,
      loadBadges,
    },
    dispatch
  )
}

class ComponentHeader extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    badge: PropTypes.string,
    //dirty:        PropTypes.bool, // set state unsaved changes
    customAction: PropTypes.object,
    customActions: PropTypes.array,
    actions: PropTypes.array,
  }

  render() {
    const dark = config.theme.dark
    // params
    const {
      title,
      badge,
      actions,
      fluid,
      customAction,
      customActions,
      disabled,
      dirty,
      type,
      icon,
      inline = false,
    } = this.props
    // redux
    const { badges } = this.props

    const componentTitle =
      title + (dirty ? ' - ' + I18n.t('global.unsaved_changes') : '')

    const headerButtons = (actions) =>
      actions.map((action, index) => (
        <Button
          {...{
            key: index,
            as: action.as,
            target: action.target,
            href: action.href,
            color: action.color,
            icon: action.icon,
            content: action.content,
            onClick: action.onClick,
            secondary: action.secondary,
            disabled: action.disabled,
            primary: action.primary,
            labelPosition: action.content && (action.labelPosition || 'right'),
            className: classNames([
              'icon',
              'hide-below-computer',
              'componentButton',
            ]),
            size: 'mini',
          }}
        />
      ))
    const headerButtonsMobile = (actions) =>
      actions.map((action, index) => (
        <Button
          {...{
            key: index,
            as: action.as,
            target: action.target,
            href: action.href,
            icon: action.icon,
            color: action.color,
            onClick: action.onClick,
            secondary: action.secondary,
            disabled: action.disabled,
            primary: action.primary,
            className: classNames([
              'icon',
              'hide-above-computer',
              'componentButton',
            ]),
            size: 'mini',
          }}
        />
      ))

    const headerCells = (actions, fluid) =>
      actions.map((customAction, index) => (
        <Table.Cell
          verticalAlign="middle"
          textAlign="right"
          collapsing
          key={index}>
          {customAction}
        </Table.Cell>
      ))

    // TODO: handle inline prop in both themes
    return (
      <Segment
        inverted={!inline}
        attached="top"
        disabled={disabled}
        className={classNames([
          'componentHeader',
          'noselect',
          dirty && 'dirty',
          type,
          dark && 'inverted',
        ])}>
        <Table basic="very" singleLine unstackable>
          <Table.Body>
            <Table.Row>
              {icon && (
                <Table.Cell
                  verticalAlign="middle"
                  collapsing
                  className="status">
                  <Icon {...icon} />
                </Table.Cell>
              )}

              {badges &&
                badge &&
                badges[badge] > 0 && (
                  <Table.Cell
                    verticalAlign="middle"
                    collapsing
                    className="status">
                    <Label color="red" className="badge">
                      {badges[badge]}
                    </Label>
                  </Table.Cell>
                )}
              <Table.Cell verticalAlign="middle">
                <Header as="h5" inverted={!inline} content={componentTitle} />
              </Table.Cell>
              {actions && (
                <Table.Cell verticalAlign="middle" textAlign="right">
                  <Button.Group>
                    {headerButtons(actions)}
                    {headerButtonsMobile(actions)}
                  </Button.Group>
                </Table.Cell>
              )}
              {customAction && (
                <Table.Cell verticalAlign="middle" textAlign="right" collapsing>
                  {customAction}
                </Table.Cell>
              )}
              {customActions && headerCells(customActions, fluid)}
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    )
  }
}

ComponentHeader = connect(mapStateToProps, mapDispatchToProps)(ComponentHeader)
export default ComponentHeader



// WEBPACK FOOTER //
// ./src/components/admin/Helper/ComponentHeader.jsx